<script setup lang="ts">
  import type { BillingAddress } from '@storefront/resources';
  import { setModelWithContext } from '@othercommerce/foundation';

  interface Props {
    addresses: BillingAddress[],
  }

  defineProps<Props>();
</script>
<template>
  <UiModal large visitable open>
    <FormController :action="$route('web.cart.billing.address.fill')" method="PATCH" v-slot="{ data, processing, ctx, submit }">
      <SfHeading>
        <h2>{{ $t('SHOP.CART.HEADER.CHOOSE_FROM_SAVED_BILLING_ADDRESSES') }}</h2>
      </SfHeading>
      <div class="addresses-grid" v-if="Object.values(addresses).length > 0">
        <SfTile class="address-card" v-for="address in addresses" interactive :selected="data.id === address?.id" @click="setModelWithContext('id', ctx, address?.id)" @keydown.space="setModelWithContext('id', ctx, address?.id)">
          <address>
            <p v-if="address?.name" class="name" v-html="address?.name" />
            <p v-if="address?.company" class="company" v-html="address?.company" />
            <p v-if="address?.firstLine" class="first-line" v-html="address?.firstLine" />
            <p v-if="address?.secondLine" class="second-line" v-html="address?.secondLine" />
            <p v-if="address?.thirdLine" class="third-line" v-html="address?.thirdLine" />
            <p v-if="address?.region" class="region" v-html="address?.region" />
            <p v-if="address?.email" class="email" v-html="address?.email" />
            <p v-if="address?.phone" class="phone" v-html="address?.phone" />
          </address>
        </SfTile>
      </div>
      <UiButtonGroup end>
        <SfButton back>
          {{ $t('SHOP.COMMON.ACTION.CANCEL') }}
        </SfButton>
        <SfButton :disabled="Object.values(data).length === 0" primary type="submit" :loading="processing" @click="submit">
          {{ $t('SHOP.CART.ACTION.CHOOSE_ADDRESS') }}
        </SfButton>
      </UiButtonGroup>
    </FormController>
  </UiModal>

  <RouterView />
</template>
<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .addresses-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 1rem;
  }

  .address-card {
    address {
      font-style: normal;

      p {
        font-size: 0.875rem;
      }
    }

    .name, .company {
      font-weight: var(--font-weight-bold);
      font-size: 1rem;
    }
  }
</style>
